import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import { NotiObj } from "utils/types/general.types";

export type NotificationsState = {
    notifications: NotiObj[];
};

const initialState: NotificationsState = {
    notifications: []
};

export const notificationsSlice = createSlice({
    name: "notifications",
    initialState,
    reducers: {
        addAllNoti: (state, action: PayloadAction<NotiObj[]>) => {
            state.notifications = action.payload;
        },
        removeAllNoti: (state) => {
            state.notifications = [];
        },
        addNoti: (state, action: PayloadAction<NotiObj>) => {
            state.notifications = [...state.notifications, action.payload];
        },
        removeNoti: (state, action: PayloadAction<string | number>) => {
            state.notifications = state.notifications.filter(
                (i) => i.id !== action.payload
            );
        },
        updateNoti: (state, action: PayloadAction<NotiObj>) => {
            state.notifications = state.notifications.map((i) =>
                i.id == action.payload.id ? action.payload : i
            );
        }
    }
});

export const { addAllNoti, removeAllNoti, addNoti, removeNoti, updateNoti } =
    notificationsSlice.actions;

export default notificationsSlice.reducer;
